// extracted by mini-css-extract-plugin
export default {"container":"TechnographicsResultsPage_container__lak58"};